import { render } from "./TabbedSection.vue?vue&type=template&id=47ad82d1&scoped=true&ts=true"
import script from "./TabbedSection.vue?vue&type=script&lang=ts"
export * from "./TabbedSection.vue?vue&type=script&lang=ts"

import "./TabbedSection.vue?vue&type=style&index=0&id=47ad82d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ad82d1"]])

export default __exports__